import React from "react";
import { UserProfile } from "../user";

export const initialUserContext: UserProfile = {
	photo: "",
	graphProfile: {
		staffId: "",
		storeLocation: "",
		storeNumber: 0,
		officeLocation: "",
		displayName: "",
		givenName: "",
		surName: "",
		roles: [""],
	},
	account: null
};

export const UserContext = React.createContext<UserProfile>(initialUserContext);
